import React from "react";
import { COLORS } from "../../theme";

// Padrão de filtro embutido no cabeçalho da tabela — usado em toda tabela
// do sistema que lista registros (em vez de uma barra de filtros separada
// em cima). Cada coluna carrega seu próprio filtro, digitável (ThFiltroTexto)
// ou selecionável (ThFiltroSelect); ThSimples é só o rótulo, pra colunas que
// não fazem sentido filtrar (ex: "Ação").
function thBaseStyle(alinhamento) {
  return { textAlign: alinhamento || "left", padding: "8px 14px 10px", verticalAlign: "top" };
}
function labelColunaStyle() {
  return { display: "block", fontSize: 10.5, fontWeight: 700, color: COLORS.textLight, textTransform: "uppercase", letterSpacing: "0.04em", marginBottom: 5, whiteSpace: "nowrap" };
}
function controleFiltroStyle() {
  return { width: "100%", boxSizing: "border-box", border: `1.5px solid ${COLORS.border}`, borderRadius: 6, padding: "5px 8px", fontSize: 12.5, background: COLORS.surface, color: COLORS.text, fontWeight: 400 };
}

export function ThFiltroTexto({ label, value, onChange, placeholder, minWidth, type = "text", alinhamento }) {
  return (
    <th style={{ ...thBaseStyle(alinhamento), minWidth }}>
      <label style={labelColunaStyle()}>{label}</label>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || (type === "text" ? "Filtrar..." : undefined)}
        style={controleFiltroStyle()}
      />
    </th>
  );
}

export function ThFiltroSelect({ label, value, onChange, opcoes, minWidth, alinhamento }) {
  return (
    <th style={{ ...thBaseStyle(alinhamento), minWidth }}>
      <label style={labelColunaStyle()}>{label}</label>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={controleFiltroStyle()}>
        {opcoes.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
      </select>
    </th>
  );
}

// Cabeçalho sem filtro (colunas de ação, ou onde filtrar não faz sentido) —
// mesma altura/alinhamento visual dos outros dois, só sem controle embaixo.
export function ThSimples({ label, minWidth, alinhamento }) {
  return (
    <th style={{ ...thBaseStyle(alinhamento), minWidth }}>
      <label style={{ ...labelColunaStyle(), marginBottom: 0 }}>{label}</label>
    </th>
  );
}

// Linha "N de M resultado(s)" + "Limpar filtros", pra ficar em cima de toda
// tabela filtrável — mesmo texto/posição em todo lugar que usa esse padrão.
export function BarraResumoFiltro({ total, totalGeral, unidade = "registro(s)", filtrosAtivos, onLimpar }) {
  return (
    <div className="no-print" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10, gap: 10, flexWrap: "wrap" }}>
      <span style={{ fontSize: 12.5, color: COLORS.textLight }}>
        {total}{totalGeral !== undefined ? ` de ${totalGeral}` : ""} {unidade}
      </span>
      {filtrosAtivos && (
        <button onClick={onLimpar} style={{ background: "none", border: "none", color: COLORS.primary, fontSize: 12, fontWeight: 600, cursor: "pointer", padding: 0, textDecoration: "underline" }}>
          Limpar filtros
        </button>
      )}
    </div>
  );
}
